export const remindersInitialState = {
	entities: {},
};



// WEBPACK FOOTER //
// ./src/redux/reminders/reminder.initialState.js